<template>
  <el-dialog
    :title="dialogTitle"
    append-to-body
    :close-on-click-modal="false"
    :visible="dialogVisible"
    center
    width="60%"
    @close="closeDialog"
  >
    <SiruiSearch
      ref="settleInfoFormRef"
      :query="settleFormData"
      :columns="formColumn"
      :isQueryPanel="false"
      :isDisabledForm="true"
    ></SiruiSearch>
    <div class="reward-box">
      <div class="reward-title">合同团队</div>
      <vxe-table
        border
        show-overflow
        resizable
        size="mini"
        align="center"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :auto-resize="true"
        :data="tableData"
      >
        <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
        <vxe-table-column field="userName" title="姓名"> </vxe-table-column>
        <vxe-table-column field="roleName" title="角色"> </vxe-table-column>
        <vxe-table-column field="commissionAmount" title="佣金金额(元)" :edit-render="{}">
          <template v-slot:edit="scope">
            <input-number
              v-if="dialogType === 'apply'"
              :max="'99999999999.99'"
              v-model="scope.row.commissionAmount"
              precision="2"
            ></input-number>
            <p v-else>{{ scope.row.commissionAmount }}</p>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="dialogType === 'settle'"
          field="settlementAmount"
          title="结算金额"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              :max="'99999999999.99'"
              v-model="scope.row.settlementAmount"
              precision="2"
            ></input-number>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="audit" v-if="dialogType === 'apply'">提交审核</el-button>
      <el-button type="primary" @click="settle" v-if="dialogType === 'settle'">确认结算</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import API from '@/api/property/reward';
  export default {
    name: 'settleDialog',
    props: ['dialogVisible', 'dialogTitle', 'dialogType', 'settleId'],
    computed: {
      formColumn() {
        return [
          {
            prop: 'rewardSettlementNo',
            name: '结算编号',
            type: 'input',
            span: 12,
          },
          {
            prop: 'nicheNo',
            name: '招商编号',
            type: 'input',
            span: 12,
          },
          {
            prop: 'contractNo',
            name: '合同编号',
            type: 'input',
            span: 12,
          },
          {
            prop: 'customerName',
            name: '客户名称',
            type: 'input',
            span: 12,
          },
          {
            prop: 'rentAmount',
            name: '租金',
            type: 'input',
            span: 12,
          },
          {
            prop: 'commissionTotalAmount',
            name: '佣金总额',
            type: 'input',
            span: 12,
          },
        ];
      },
    },
    data() {
      return {
        settleFormData: {
          rewardSettlementNo: 'ZS202201',
          nicheNo: 'ZSBH2022001',
          contractNo: 'ZNHT20220001',
          customerName: '西正丰源商贸有限公司',
          rentAmount: '2000.00',
          commissionTotalAmount: '2500',
        },
        tableData: [],
      };
    },
    created() {
      if (this.settleId) {
        // 获取详情
        this.getRewardDetail();
      }
    },
    methods: {
      getRewardDetail() {
        this.$axios.get(API.REWARD_DETAIL + '/' + this.settleId).then((res) => {
          if (res.data.code === 0) {
            const detailData = res.data.data || {};
            console.log(detailData, 'detailData');
            const baseInfo = {
              rewardSettlementNo: detailData.rewardSettlementNo || 'rewardSettlementNo',
              nicheNo: detailData.nicheNo || 'nicheNo',
              contractNo: detailData.contractNo || 'contractNo',
              customerName: detailData.customerName || 'contractNo',
              rentAmount: detailData.rentAmount || 'rentAmount',
              commissionTotalAmount: detailData.commissionTotalAmount || 'commissionTotalAmount',
            };
            Object.assign(this.settleFormData, baseInfo);
            this.tableData = detailData.nicheRewardSettlementLines || [];
          }
        });
      },
      closeDialog() {
        this.$emit('close');
      },
      audit() {
        console.log('audit');
        // 佣金总额不可大于“租金
        let amount = 0;
        let arr = [];
        this.tableData.forEach((table) => {
          amount = amount + Number(table.commissionAmount);
          arr.push({
            id: table.id,
            rewardSettlementId: table.rewardSettlementId,
            commissionAmount: table.commissionAmount,
          });
        });
        this.settleFormData.commissionTotalAmount = amount + '';
        if (amount > Number(this.settleFormData.rentAmount)) {
          return this.$message({
            showClose: true,
            message: '佣金总额不可大于租金！',
            type: 'error',
          });
        }
        if (this.settleId) {
          const params = {};
          params.id = this.settleId;
          params.nicheRewardSettlementLines = arr;
          this.$axios.post(API.REWARD_APPROVAL_SUBMIT, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.$emit('close', 'refresh');
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      settle() {
        console.log('settle');
        // 结算金额合计值不可超过佣金总额
        let amount = 0;
        const arr = [];
        this.tableData.forEach((table) => {
          amount = amount + Number(table.settlementAmount);
          arr.push({
            id: table.id,
            rewardSettlementId: table.rewardSettlementId,
            settlementAmount: table.settlementAmount,
          });
        });
        if (amount > Number(this.settleFormData.commissionTotalAmount)) {
          return this.$message({
            showClose: true,
            message: '结算金额合计值不可超过佣金总额！',
            type: 'error',
          });
        }
        const params = {};
        // Object.assign(params, this.settleFormData);
        params.id = this.settleId;
        params.nicheRewardSettlementLines = arr;
        this.$axios.post(API.REWARD_SETTLEMENT, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
            this.$emit('close', 'refresh');
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .reward-box {
    margin-bottom: 20px;
    .reward-title {
      height: 40px;
      line-height: 40px;
      margin-bottom: 15px;
    }
  }
</style>
